import React, { useState, useEffect } from "react";
import {
  Box,
  Grid,
  InputAdornment,
  TextField,
  CircularProgress,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { SearchingService } from "services/SearchingService";
import { useAuth } from "context/authContext";

const SearchBarCommon: React.FC = () => {
  const { searchTerm, setSearchTerm } = useAuth();
  const [debounceTimeout, setDebounceTimeout] = useState<NodeJS.Timeout | null>(
    null
  );

  // // Function to handle search
  // const fetchSearchResults = async (term: string) => {
  //   if (!term.trim()) {
  //     onSearch([]); // Clear results if input is empty
  //     // setIsSearched(false);
  //     return;
  //   }

  //   setIsLoading(true);
  //   // setIsSearched(true);

  //   try {
  //     const results = await SearchingService.searchGlobal(term.trim());
  //     console.log("Fetched Results:", results); // Debugging here
  //     onSearch(results);
  //   } catch (error) {
  //     console.error("Search Error:", error);
  //     onSearch([]); // Ensure state resets on error
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  // Handle input changes and debounce search
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearchTerm(value);

    if (debounceTimeout) clearTimeout(debounceTimeout);

    // Debounce for 500ms
    const timeout = setTimeout(() => {
      setSearchTerm(value);
    }, 500);

    setDebounceTimeout(timeout);
  };

  return (
    <Grid container alignItems="center">
      <TextField
        variant="outlined"
        fullWidth
        size="small"
        placeholder="Search for courses, handouts, instructors, and more "
        value={searchTerm}
        onChange={handleInputChange}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Box
                component="img"
                src="/assets/icons/searchIcon.svg"
                alt="search Logo"
              />
            </InputAdornment>
          ),
        }}
        sx={styleSheet.field}
      />
    </Grid>
  );
};

export default SearchBarCommon;

const styleSheet = {
  field: {
    backgroundColor: "white",
    borderRadius: "15px",
    width: { xs: "97%", md: "394px" },

    "& .MuiInputBase-input::placeholder": {
      fontFamily: "Atten Round New",

      color: "#7885AA",
      fontSize: "15px",
      fontWeight: "400",
      opacity: 1,
    },
    "& fieldset": {
      borderColor: "transparent", // Remove border
    },
    "&:hover fieldset": {
      borderColor: "transparent", // Remove hover border
    },
    "&.Mui-focused fieldset": {
      borderColor: "transparent", // Remove focus border
    },
  },
};
